<template>
    <div class="min-vw-auto max-vw-none min-vw-lg-30 max-vw-lg-50 notifications-menu">
        <list-group :flush="true" class="max-vh-70 overflow-auto">
            

            <template v-if="guestPendingBookings">
                <menu-notifications-pending-booking v-for="booking in guestPendingBookings" :key="`menu-notification-guest-booking-${booking.id}`" :booking="booking" @click="$emit('click')" />
            </template>

            <menu-notifications-w9-required @click="$emit('click')" v-if="w9Required"/>
            <menu-notifications-open-invoices @click="$emit('click')" v-if="openInvoices" :openInvoices="openInvoices"/>

            <menu-notifications-pending-inqueries @click="$emit('click')" v-if="pendingInqueries" :pendingInqueries="pendingInqueries"/>
            <menu-notifications-pending-home-vision @click="$emit('click')" v-if="homeVisionId" :homeVisionId="homeVisionId"/>

            <template v-if="resCenterBookings">
                <menu-notifications-pending-res-center v-for="resCenterBooking in resCenterBookings" :key="`menu-notification-booking-${resCenterBooking.id}`" :resCenter="resCenterBooking" @click="$emit('click')" />
            </template>

            <menu-notifications-pending-issue @click="$emit('click')" v-if="pendingApprovalRequests > 0" />

            <menu-notifications-post-inspection-reports @click="$emit('click')" v-if="pendingInspectionReports > 0" :pendingInspectionReports="pendingInspectionReports" />
        
            <template v-if="bookings">
                <menu-notifications-booking v-for="booking in bookings" :key="`menu-notification-booking-${booking.id}`" :booking="booking" @click="$emit('click')" />
            </template>

            <menu-notifications-missing-broker-info @click="$emit('click')" v-if="missingBrokerInfo"/>
            <menu-notifications-missing-travel-agent-info @click="$emit('click')" v-if="missingTravelAgentInfo"/>

            <template v-if="messages && messages.length">
                <menu-notifications-message v-for="message in messages" :key="`menu-notification-message-${message.id}`" :message="message" @click="$emit('click')" @showMessage="showMessage" />
            </template>
            <list-group-item v-if="noNotifications">
                No new notifications or pending items.
            </list-group-item>

            <list-group-item :to="profileLink" @click="$emit('click')">
                View All Notifications
            </list-group-item>
        </list-group>
    </div>
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';
    import MenuNotificationsMessage from '@/components/Layout/Notifications/Items/Message.vue';
    import MenuNotificationsW9Required from '@/components/Layout/Notifications/Items/W9Required.vue';
    import MenuNotificationsMissingBrokerInfo from '@/components/Layout/Notifications/Items/MissingBrokerInfo.vue';
    import MenuNotificationsMissingTravelAgentInfo from '@/components/Layout/Notifications/Items/MissingTravelAgentInfo.vue';
    import MenuNotificationsOpenInvoices from '@/components/Layout/Notifications/Items/OpenInvoices.vue';

    import MenuNotificationsBooking from '@/components/Layout/Notifications/Items/Booking.vue';
    import MenuNotificationsPendingBooking from '@/components/Layout/Notifications/Items/PendingBooking.vue';
    import MenuNotificationsPendingInqueries from '@/components/Layout/Notifications/Items/PendingInqueries.vue';
    import MenuNotificationsPendingHomeVision from '@/components/Layout/Notifications/Items/PendingHomeVision.vue';
    import MenuNotificationsPendingResCenter from '@/components/Layout/Notifications/Items/PendingResCenter.vue';
    import MenuNotificationsPostInspectionReports from '@/components/Layout/Notifications/Items/PostInspectionReports.vue';
    import MenuNotificationsPendingIssue from '@/components/Layout/Notifications/Items/PendingIssue.vue';

    import MenuNotifications from '@/classes/MenuNotifications.js';

    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            MenuNotificationsPendingBooking,
            MenuNotificationsMessage,
            MenuNotificationsW9Required,
            MenuNotificationsOpenInvoices,
            MenuNotificationsMissingBrokerInfo,
            MenuNotificationsMissingTravelAgentInfo,
            MenuNotificationsBooking,
            MenuNotificationsPendingInqueries,
            MenuNotificationsPendingHomeVision,
            MenuNotificationsPendingResCenter,
            MenuNotificationsPostInspectionReports,
            MenuNotificationsPendingIssue,
            ...UIComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                todo: MenuNotifications.todo,
                messages: MenuNotifications.messages,
            };
        },

        emits: ['click', 'showMessage'],

        computed: {

            guestPendingBookings() {
                if ((this.todo) && (this.todo.guestPendingBookings) && (this.todo.guestPendingBookings.length)) {
                    return this.todo.guestPendingBookings;
                }

                return null;
            },

            // this is for owners requested bookings
            bookings() {
                if ((this.todo) && (this.todo.requestedBookings) && (this.todo.requestedBookings.length)) {
                    return this.todo.requestedBookings;
                }

                return null;
            },

            pendingInqueries() {
                return ((this.todo) && (this.todo.pendingInqueries));
            },

            homeVisionId() {
                if ((this.todo) && (this.todo.homeVisionId)) {
                    return this.todo.homeVisionId;
                }
                return null;
            },

            resCenterBookings() {
                if ((this.todo) && (this.todo.resCenterBookings) && (this.todo.resCenterBookings.length)) {
                    return this.todo.resCenterBookings;
                }
                return null;
            },

            pendingInspectionReports() {
                if ((this.todo) && (this.todo.postInspectionReports)) {
                    return this.todo.postInspectionReports;
                }

                return 0;
            },

            pendingApprovalRequests() {
                if ((this.todo) && (this.todo.pendingApprovalRequests)) {
                    return this.todo.pendingApprovalRequests;
                }
                return 0;
            },

            w9Required() {
                return ((this.todo) && (this.todo.w9Required));
            },

            openInvoices() {
                return ((this.todo) && (this.todo.openInvoices));
            },

            missingBrokerInfo() {
                return ((this.todo) && (this.todo.missingBrokerInfo))
            },

            missingTravelAgentInfo() {
                return ((this.todo) && (this.todo.missingTravelAgentInfo))
            },

            noNotifications() {
                if (
                    (! this.guestPendingBookings) &&
                    (! this.bookings) &&
                    (! this.pendingInqueries) &&
                    (! this.homeVisionId) &&
                    (! this.resCenterBookings) &&
                    (! this.pendingInspectionReports) &&
                    (! this.w9Required) &&
                    (! this.missingBrokerInfo) &&
                    (! this.missingTravelAgentInfo) &&
                    (! this.openInvoices) &&
                    (! this.pendingApprovalRequests) &&
                    ((! this.messages) || (this.messages.length == 0))
                ) {
                    return true;
                }
                return false;
            },

            profileLink() {
                let homepage = this.uiStore.homePageLink;
                if (homepage == '/') {
                    homepage = '/travelers';
                }
                
                return homepage+'/profile/notifications';
            },
        },

        methods: {
            showMessage(message) {
                this.$emit('showMessage', message);
            },
        }
    }
</script>